import React, { Component } from 'react';

//other components
import TextBox from "../input_boxes/TextBox";
import CustomCheckBox from "./CustomCheckBox";

//generic functions
import {
    isEmpty,
    cloneObject
} from "../../../functions/generic_functions";

/*
    props:
        onChangeSetParentState => changes parent state function
        name => name of this component
        value => set the value of this component from the parent
        checkBoxOptions => array list of checkbox options to load with

            expected structure:
                [
                        {
                            id: 1
                            value: "Beedie Work for Us Page",
                            other_name: "",
                            checked: false,
                            do_display_other: true/false
                        },
                        {
                            id
                            value: "Caut",
                            other_name: "",
                            checked: false,
                            do_display_other: true/false
                        },
                ],
        required => true/false if this field is required => if required, show red borders for all checkboxes if not checked
        min_required => number of checkboxes required for red borders for checkboxes to disappear

        textbox shows red colored textbox
        disabled => true/false disables the checkboxes btn

        otherTextBoxData {
            otherOptionTextRequired true/false if this field is required => if required, and other checkbox is checked, and empty 
            otherOptionTextBoxName => the name of the other textbox
            otherOptionTextBoxMaxLength => the max length of the textbox,
            otherOptionTextBoxPlaceholder => the placeholder of the other textbox,
            otherOptionTextBoxClassName => the class name of the other text box
        }
*/

class CheckBoxList extends Component {

    render() {
        return (
            <div>
                {(!isEmpty(this.props.checkBoxOptions) && this.props.checkBoxOptions.length > 0) ?
                    this.props.checkBoxOptions.map(function (data, i) {

                        var otherTextBoxData = undefined;
                        var checkbox_id = data.id;

                        //build the otherTextBoxData if the do_display_other is true 
                        if(data.do_display_other) {
                            otherTextBoxData = cloneObject(this.props.otherTextBoxData);

                            otherTextBoxData['otherOptionTextBoxValue'] = data.other_name;

                            //construct a name with ? as the seperator for checkbox checkbox id
                            otherTextBoxData['otherOptionTextBoxName'] = "positionSourceListOtherName" + "?" + checkbox_id;
                        }
                        
                        //build the next check box with padding depending on if it has otherTextBoxData
                        return (
                            <div key={i} 
                                className={" checkbox_list_element_format " + (!isEmpty(this.props.className) ? this.props.className : "") }
                            >
                                <CustomCheckBox
                                    name={"positionSourceListCheckbox"+ "?" + checkbox_id}
                                    value={data.value}
                                    label={data.value}
                                    onChangeSetParentState={this.props.onChangeSetParentState}
                                    checked={data.checked}
                                    disabled={this.props.disabled}
                                    otherTextBoxData={otherTextBoxData}
                                />
                                <br/>
                            </div>
                        );
                    }.bind(this))
                : null}
            </div>
        );
    }
}

/*
className={""
                                        + (!isEmpty(this.props.className) ? this.props.className : "")
                                        + ((i < this.props.checkBoxOptions.length - 2) ? " checkbox_list_element_format" : "") + ((!isEmpty(this.props.otherTextBoxData) && (i === this.props.checkBoxOptions.length - 2))? " checkbox_list_other_text_box_padding" : "")}
*/
export default CheckBoxList;